import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

const initialState = {
  ministries: [],
  loading: false,
  error: null,
};

export const fetchMinistries = createAsyncThunk('ministries/fetchMinistries', async () => {
  const response = await api.get('/ministries');
  if (response.data && Array.isArray(response.data.data)) {
    return response.data.data;
  }
  if (Array.isArray(response.data)) {
    return response.data;
  }
  throw new Error('Unexpected data format');
});

export const createMinistry = createAsyncThunk('ministries/createMinistry', async (ministryData) => {
  const response = await api.post('/ministries', ministryData);
  return response.data.data;
});

const ministrySlice = createSlice({
  name: 'ministries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMinistries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMinistries.fulfilled, (state, action) => {
        state.loading = false;
        state.ministries = action.payload;
      })
      .addCase(fetchMinistries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch ministries';
      })
      .addCase(createMinistry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMinistry.fulfilled, (state, action) => {
        state.loading = false;
        state.ministries.push(action.payload);
      })
      .addCase(createMinistry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to create ministry';
      });
  },
});

export default ministrySlice.reducer;
